import { useEffect, useState } from "react";
import MultiTable from "../../../../Common/MUITable";
import { ExportInspectionReport } from "../ExportInspectionReport";
import InspectionReportFilter from "../InspectionReportFilter";
import { getInspectionReportWards } from "../inspectionReportApi";
import { useConditionsOfAutoTippersStore } from "./store/useConditionsOfAutoTippersStore";

const columns = [
  {
    label: "Ward",
    field: "wardId",
    width: "120px",
    render: (row) => row.circleName ?? row.wardName ?? "N/A",
  },
  { label: "Vehicle Registration No.", field: "vehicleRegistrationNo", width: "180px" },
  { label: "Asset Code", field: "assetCode", width: "150px" },
  { label: "Asset Type", field: "assetType", width: "150px" },
  { label: "Date of inspection", field: "dateOfInspection", width: "140px" },
  { label: "Vehicle Condition", field: "vehicleCondition", width: "140px" },
  { label: "Any damage", field: "anyDamage", width: "110px" },
  { label: "Paint & signage", field: "paintAndSignage", width: "130px" },
  { label: "Is GPS functional or not", field: "isGpsFunctionalOrNot", width: "170px" },
  { label: "Last Service date", field: "lastServiceDate", width: "140px" },
];

const ConditionsOfAutoTippersReport = () => {
  const [wardOptions, setWardOptions] = useState([]);
  const {
    rows,
    filters,
    isLoading,
    page,
    pageSize,
    totalRecords,
    fetchReport,
    resetFilters,
    changePage,
    changePageSize,
    fetchExportData,
  } = useConditionsOfAutoTippersStore();

  useEffect(() => {
    const loadMasterData = async () => {
      try {
        const wards = await getInspectionReportWards();
        setWardOptions(wards.filter((ward) => ward.isActive !== false));
      } catch (error) {
        console.error("Failed to load inspection report wards:", error);
        setWardOptions([]);
      }
    };

    loadMasterData();
    fetchReport(filters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="content text-start">
      <div className="page-content">
        <div className="d-flex justify-content-between align-items-start flex-wrap gap-3 mt-3">
          <div>
            <h5 className="mb-1 fw-semibold">Conditions Of Auto-tippers(4-Wheeler&3-Wheeler)</h5>
            <p className="text-muted mb-0">
             Manage and monitor inspection records of Auto-tippers(4-Wheeler&3-Wheeler) across all zones and wards.
            </p>
          </div>
          <div className="d-flex align-items-center flex-wrap">
            <ExportInspectionReport
              reportData={rows}
              loadExportData={fetchExportData}
              reportTitle="Conditions Of Auto-tippers"
              columns={columns}
              fileName="ConditionsOfAutoTippers"
            />
          </div>
        </div>
        <div className="card shadow mt-3">
          <div className="card-body">
            <InspectionReportFilter
              initialValues={filters}
              wardOptions={wardOptions}
              onSearch={fetchReport}
              onReset={resetFilters}
            />
            <div className="top-header text-center">
              <span>Conditions Of Auto-tippers</span>
            </div>
            <MultiTable
              loading={isLoading}
              needSRNumber
              rows={rows}
              columns={columns}
              serverPagination
              totalCount={totalRecords}
              page={page}
              rowsPerPage={pageSize}
              onPageChange={(_event, newPage) => changePage(newPage)}
              onRowsPerPageChange={(event) =>
                changePageSize(parseInt(event.target.value, 10))
              }
              rowsPerPageOptions={[10, 50, 100, 1000, 10000, 50000]}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConditionsOfAutoTippersReport;
